var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "functional_region",
      style: {
        height: `calc(100% - ${
          (parseInt(_vm.allUsers.length / 2)
            ? parseInt(_vm.allUsers.length / 2)
            : 1) *
            80 +
          5
        }px)`,
      },
    },
    [
      _c("div", { staticClass: "chatArea" }, [
        _c(
          "ul",
          { staticClass: "im-log-box", attrs: { id: "msg_box" } },
          [
            !_vm.isCompleted
              ? _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: { click: _vm.viewMoreMsg },
                      },
                      [_vm._v("查看更多")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.msgs, function (msg, index) {
              return [
                msg.payload.description && msg.payload.description != "fn"
                  ? _c(
                      "li",
                      {
                        key: index,
                        class: _vm.classData.userId == msg.from ? "my" : "",
                      },
                      [
                        _c("span", { staticClass: "send" }, [
                          _vm._v(_vm._s(msg.payload.extension)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _c("span", {
                            class:
                              _vm.classData.userId == msg.from
                                ? "mytriangleIcon"
                                : "triangleIcon",
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class:
                                _vm.classData.userId == msg.from
                                  ? "contentBox"
                                  : "myContent contentBox",
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    msg.payload.description == "text"
                                      ? msg.payload.data
                                      : ""
                                  ) +
                                  "\n                            "
                              ),
                              msg.payload.description == "emoji"
                                ? _c("img", {
                                    staticClass: "emojiImg",
                                    attrs: {
                                      src: `${
                                        _vm.emojiIcon[msg.payload.data].img
                                      }`,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              msg.payload.description == "img"
                                ? _c(
                                    "div",
                                    { staticClass: "demo-image__preview" },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                        },
                                        attrs: {
                                          src: msg.payload.data,
                                          "preview-src-list": [
                                            msg.payload.data,
                                          ],
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              msg.payload.description == "file"
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadFile(
                                                msg.payload.data
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              msg.payload.data.split(
                                                "/name+"
                                              )[1]
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              msg.payload.description == "voice"
                                ? _c(
                                    "div",
                                    {
                                      class:
                                        _vm.classData.userId == msg.from
                                          ? "voiceIconImg my"
                                          : "voiceIconImg",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlerVoice(
                                            `voice${index}`
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: { height: "100%" },
                                        attrs: { src: _vm.voiceIcon[2] },
                                      }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            `${
                                              msg.payload.data.split(
                                                "/time+"
                                              )[1]
                                            }\"`
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              msg.payload.description == "voice"
                                ? _c("audio", {
                                    ref: `voice${index}`,
                                    refInFor: true,
                                    staticStyle: { width: "10px" },
                                    attrs: {
                                      src: `${
                                        msg.payload.data.split("/time+")[0]
                                      }`,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "functional_region_foot_tab" }, [
        _c(
          "div",
          { staticClass: "flex_row" },
          [
            _c("Emoji", {
              attrs: { enableChat: _vm.enableChat },
              on: { sendEmojiMessage: _vm.sendEmojiMessage },
            }),
            _vm._v(" "),
            _c(
              "el-tooltip",
              {
                attrs: {
                  content: "发送语音（按住说话，松开发送）",
                  placement: "top",
                  effect: "light",
                },
              },
              [
                _c("span", {
                  staticClass: "voiceIcon",
                  on: {
                    mousedown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft",
                        ])
                      )
                        return null
                      if ("button" in $event && $event.button !== 0) return null
                      return _vm.handlerVoicePlay.apply(null, arguments)
                    },
                    mouseup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft",
                        ])
                      )
                        return null
                      if ("button" in $event && $event.button !== 0) return null
                      return _vm.handlerVoiceStop.apply(null, arguments)
                    },
                    mouseout: _vm.handlerVoiceStop,
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("PicUpload", {
              attrs: { enableChat: _vm.enableChat },
              on: { imgUploadSuccess: _vm.imgUploadSuccess },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "hands_btn_box" }, [
          _c(
            "div",
            { staticClass: "hands_btn", on: { click: _vm.raiseHand } },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "举手上台",
                    placement: "top",
                    effect: "light",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/tic/stuhand.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.input_speak == "speak"
        ? _c(
            "div",
            [_c("SpeakLoading", { attrs: { isplay: _vm.speckLoadingPlay } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.input_speak == "input"
        ? _c(
            "div",
            { staticClass: "commonBox" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: "2",
                  placeholder: _vm.enableChat ? "请输入内容" : "当前禁言",
                  resize: "none",
                  maxlength: "50",
                  disabled: !_vm.enableChat,
                },
                nativeOn: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.sendTextMsg.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.msgContent,
                  callback: function ($$v) {
                    _vm.msgContent = $$v
                  },
                  expression: "msgContent",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { disabled: !_vm.enableChat, type: "primary" },
                  on: { click: _vm.sendTextMsg },
                },
                [_vm._v("发送")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("CardAnimation", {
        ref: "cardAnimationRef",
        attrs: { img: _vm.awardCardImg },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/chatArea.vue?vue&type=template&id=7bb8dcb2&scoped=true&
// module id = null
// module chunks = 